module.exports = __webpack_public_path__ + "img/lg_ring_y_e_1_1.055ff6f2.png";